import * as buttonText from './ui-button-text.js'

export default async function procShuffle(params) {
    const { app, w, h, cards } = params;

    // Spread cards
    const pArr = cards.map((card, i) => {
        let x, y;
        do {
            x = w * 0.2 + Math.random() * w * 0.6;
            y = h * 0.2 + Math.random() * h * 0.6;
        } while(Math.abs(w / 2 - x) + Math.abs(h / 2 - y) < w * 0.1)

        return anime({targets: card, x, y, duration: 500, easing: 'linear'}).finished;
    });
    await Promise.all(pArr);

    // Shuffle
    cards.forEach((card, i) => {
        const cx = w / 2;
        const cy = h / 2;
        const x = card.x - cx;
        const y = card.y - cy;
        const distance = Math.sqrt(x ** 2 + y ** 2);
        const radian = Math.atan2(y, x);
        anime({ targets: card, duration: 4000, easing: 'linear', loop: true,
            update: anim => {
                const rate = anim.progress / 100;
                const radian2 = radian + Math.PI * 2 * rate;
                card.x = cx + distance * Math.cos(radian2);
                card.y = cy + distance * Math.sin(radian2);
            }
        });
    });

    // Button - End shuffle
    await new Promise(resolve => {
        const text = 'シャッフル終了';
        const button = buttonText.gen(app, text, () => {
            button.destroy();
            cards.forEach(card => anime.remove(card));
            resolve();
        });
        button.y = h * 0.9;
        button.zIndex = 1;
    });
}
